import { Routes, Route, Navigate } from 'react-router-dom'
import { TenantProvider } from '../tenant/TenantProvider'
import { AppShell } from '../components/layout/AppShell'
import { HomePage } from '../pages/home/HomePage'
import { ServicesPage } from '../pages/services/ServicesPage'
import { BranchesPage } from '../pages/branches/BranchesPage'
import { BookingWizard } from '../pages/booking/BookingWizard'
import { SignInPage } from '../pages/auth/SignInPage'
import { SignUpRoutes } from '../pages/auth/SignUpRoutes'
import { ResetRoutes } from '../pages/auth/ResetRoutes'
import { VerifyEmailPage } from '../pages/auth/VerifyEmailPage'
import { AccountRoutes } from '../pages/account/AccountRoutes'
import { NotFoundPage } from '../pages/NotFoundPage'
import { LandingRedirect } from '../pages/LandingRedirect'

/**
 * Every route is scoped by /{slug}. There is no root-level storefront: hitting
 * storefront.vegabooking.io without a slug is a mistake, not a page.
 */
export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingRedirect />} />
      <Route
        path="/:slug/*"
        element={
          <TenantProvider>
            <TenantRoutes />
          </TenantProvider>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

function TenantRoutes() {
  return (
    <Routes>
      {/* The wizard runs outside the shell: it has its own chrome and a
          progress header, and the site nav is a distraction mid-booking. */}
      <Route path="book/*" element={<BookingWizard />} />

      <Route element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="branches" element={<BranchesPage />} />
        <Route path="signin" element={<SignInPage />} />
        <Route path="signup/*" element={<SignUpRoutes />} />
        <Route path="reset/*" element={<ResetRoutes />} />
        {/* Link in the sign-up mail (OC-340). */}
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="account/*" element={<AccountRoutes />} />
        {/* Legacy Blade path kept alive so old links land somewhere sensible. */}
        <Route path="quick-booking" element={<Navigate to="../book" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
